import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import CheckboxGroup from '../../../exportacion_react_pdf/CheckboxGroup';
import QuestionResponse from '../../../exportacion_react_pdf/QuestionResponse';


// Define el documento
const ExportPaso3 = ({ formData, styles }) => (
    <>
        {/* Sección de Identificació del proyecto */}
        <View style={styles.section}>

            <Text style={styles.title_1}>III. Información de la unidad productiva </Text>


            <QuestionResponse
                label={'¿Nombre del proyecto?'}
                value={formData?.nombreProyecto || ''}>
            </QuestionResponse>

            <QuestionResponse
                label={'¿Código PRE/INI?'}
                value={formData?.codigoPreIni || ''}>
            </QuestionResponse>



            <CheckboxGroup
                label='¿Tipo de proyecto?'
                selectedValue={formData?.tipoProyecto || ''}
                options={["Asociativo", "Individual"]}>
            </CheckboxGroup>

            <CheckboxGroup
                label='¿Actualmente el proyecto se encuentra?'
                selectedValue={formData?.estadoProyecto || ''}
                options={["Activo", "Inactivo"]}>
            </CheckboxGroup>

            <QuestionResponse
                label={'¿A qué línea productiva pertenece?'}
                value={formData?.lineaProductiva || ''}>
            </QuestionResponse>


            <CheckboxGroup
                label='¿Existe algún cambio respecto a la línea productiva inicialmente establecida?'
                selectedValue={formData?.cambioLineaProductiva || ''}>
            </CheckboxGroup>

            {formData?.cambioLineaProductiva === 'Sí' && (
                <CheckboxGroup
                    label='¿Cuenta con el documento que avala este cambio debidamente diligenciado?'
                    selectedValue={formData?.documento_avala_cambio_diligenciado || ''}>
                </CheckboxGroup>
            )}

            <CheckboxGroup
                label='¿Cuál es la tenencia del predio actualmente?'
                selectedValue={formData?.tenenciaPredio || ''}
                options={["Propio", "Arrendado", "Comodato", "Al aumento", "Otro"]}>
            </CheckboxGroup>


            {formData?.tenenciaPredio === 'Otro' && (

                <QuestionResponse
                    label={'¿Especifique otro tipo de tenencia?'}
                    value={formData?.otraTenenciaPredio || ''}>
                </QuestionResponse>


            )}

            <QuestionResponse
                label={'¿Cuál es el área total del predio m2?'}
                value={formData?.areaPredio || ''}>
            </QuestionResponse>


            <QuestionResponse
                label={'¿El predio se encuentra ubicado en alguna de estas zonas?'}
                value={formData?.zonaPredio || ''}>
            </QuestionResponse>
        </View>
    </>
);

export default ExportPaso3;